module.exports = __webpack_public_path__ + "img/plane_track_mobile_2.9476fb8b.svg";